// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/app/v1/app.proto (package penumbra.core.app.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Transaction } from "../../transaction/v1/transaction_pb.js";
import { GenesisContent as GenesisContent$5, SctParameters } from "../../component/sct/v1/sct_pb.js";
import { CommunityPoolParameters, GenesisContent as GenesisContent$6 } from "../../component/community_pool/v1/community_pool_pb.js";
import { GenesisContent as GenesisContent$3, GovernanceParameters } from "../../component/governance/v1/governance_pb.js";
import { GenesisContent as GenesisContent$4, IbcParameters } from "../../component/ibc/v1/ibc_pb.js";
import { GenesisContent as GenesisContent$1, StakeParameters } from "../../component/stake/v1/stake_pb.js";
import { FeeParameters, GenesisContent as GenesisContent$7 } from "../../component/fee/v1/fee_pb.js";
import { DistributionsParameters, GenesisContent as GenesisContent$8 } from "../../component/distributions/v1/distributions_pb.js";
import { FundingParameters, GenesisContent as GenesisContent$9 } from "../../component/funding/v1/funding_pb.js";
import { GenesisContent as GenesisContent$2, ShieldedPoolParameters } from "../../component/shielded_pool/v1/shielded_pool_pb.js";
import { DexParameters, GenesisContent as GenesisContent$10 } from "../../component/dex/v1/dex_pb.js";
import { AuctionParameters, GenesisContent as GenesisContent$11 } from "../../component/auction/v1/auction_pb.js";
/**
 * Requests the list of all transactions that occurred within a given block.
 *
 * @generated from message penumbra.core.app.v1.TransactionsByHeightRequest
 */
export class TransactionsByHeightRequest extends Message {
    /**
     * The block height to retrieve.
     *
     * @generated from field: uint64 block_height = 2;
     */
    blockHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.app.v1.TransactionsByHeightRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionsByHeightRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionsByHeightRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionsByHeightRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionsByHeightRequest, a, b);
    }
}
/**
 * A transaction that appeared within a given block.
 *
 * @generated from message penumbra.core.app.v1.TransactionsByHeightResponse
 */
export class TransactionsByHeightResponse extends Message {
    /**
     * The transactions.
     *
     * @generated from field: repeated penumbra.core.transaction.v1.Transaction transactions = 1;
     */
    transactions = [];
    /**
     * The block height.
     *
     * @generated from field: uint64 block_height = 2;
     */
    blockHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.app.v1.TransactionsByHeightResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "transactions", kind: "message", T: Transaction, repeated: true },
        { no: 2, name: "block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionsByHeightResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionsByHeightResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionsByHeightResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionsByHeightResponse, a, b);
    }
}
/**
 * @generated from message penumbra.core.app.v1.AppParameters
 */
export class AppParameters extends Message {
    /**
     * The chain identifier.
     *
     * @generated from field: string chain_id = 1;
     */
    chainId = "";
    /**
     * Sct module parameters.
     *
     * @generated from field: penumbra.core.component.sct.v1.SctParameters sct_params = 2;
     */
    sctParams;
    /**
     * Community Pool module parameters.
     *
     * @generated from field: penumbra.core.component.community_pool.v1.CommunityPoolParameters community_pool_params = 3;
     */
    communityPoolParams;
    /**
     * Governance module parameters.
     *
     * @generated from field: penumbra.core.component.governance.v1.GovernanceParameters governance_params = 4;
     */
    governanceParams;
    /**
     * IBC module parameters.
     *
     * @generated from field: penumbra.core.component.ibc.v1.IbcParameters ibc_params = 5;
     */
    ibcParams;
    /**
     * Stake module parameters.
     *
     * @generated from field: penumbra.core.component.stake.v1.StakeParameters stake_params = 6;
     */
    stakeParams;
    /**
     * Fee module parameters.
     *
     * @generated from field: penumbra.core.component.fee.v1.FeeParameters fee_params = 7;
     */
    feeParams;
    /**
     * Distributions module parameters.
     *
     * @generated from field: penumbra.core.component.distributions.v1.DistributionsParameters distributions_params = 8;
     */
    distributionsParams;
    /**
     * Funding module parameters.
     *
     * @generated from field: penumbra.core.component.funding.v1.FundingParameters funding_params = 9;
     */
    fundingParams;
    /**
     * Shielded pool module parameters.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.ShieldedPoolParameters shielded_pool_params = 10;
     */
    shieldedPoolParams;
    /**
     * DEX module parameters.
     *
     * @generated from field: penumbra.core.component.dex.v1.DexParameters dex_params = 11;
     */
    dexParams;
    /**
     * Auction module parameters.
     *
     * @generated from field: penumbra.core.component.auction.v1.AuctionParameters auction_params = 12;
     */
    auctionParams;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.app.v1.AppParameters";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "chain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "sct_params", kind: "message", T: SctParameters },
        { no: 3, name: "community_pool_params", kind: "message", T: CommunityPoolParameters },
        { no: 4, name: "governance_params", kind: "message", T: GovernanceParameters },
        { no: 5, name: "ibc_params", kind: "message", T: IbcParameters },
        { no: 6, name: "stake_params", kind: "message", T: StakeParameters },
        { no: 7, name: "fee_params", kind: "message", T: FeeParameters },
        { no: 8, name: "distributions_params", kind: "message", T: DistributionsParameters },
        { no: 9, name: "funding_params", kind: "message", T: FundingParameters },
        { no: 10, name: "shielded_pool_params", kind: "message", T: ShieldedPoolParameters },
        { no: 11, name: "dex_params", kind: "message", T: DexParameters },
        { no: 12, name: "auction_params", kind: "message", T: AuctionParameters },
    ]);
    static fromBinary(bytes, options) {
        return new AppParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppParameters, a, b);
    }
}
/**
 * Requests the global configuration data for the app.
 *
 * @generated from message penumbra.core.app.v1.AppParametersRequest
 */
export class AppParametersRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.app.v1.AppParametersRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new AppParametersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppParametersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppParametersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppParametersRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.app.v1.AppParametersResponse
 */
export class AppParametersResponse extends Message {
    /**
     * @generated from field: penumbra.core.app.v1.AppParameters app_parameters = 1;
     */
    appParameters;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.app.v1.AppParametersResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "app_parameters", kind: "message", T: AppParameters },
    ]);
    static fromBinary(bytes, options) {
        return new AppParametersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppParametersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppParametersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppParametersResponse, a, b);
    }
}
/**
 * @generated from message penumbra.core.app.v1.GenesisAppState
 */
export class GenesisAppState extends Message {
    /**
     * @generated from oneof penumbra.core.app.v1.GenesisAppState.genesis_app_state
     */
    genesisAppState = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.app.v1.GenesisAppState";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "genesis_content", kind: "message", T: GenesisContent, oneof: "genesis_app_state" },
        { no: 2, name: "genesis_checkpoint", kind: "scalar", T: 12 /* ScalarType.BYTES */, oneof: "genesis_app_state" },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisAppState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisAppState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisAppState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisAppState, a, b);
    }
}
/**
 * @generated from message penumbra.core.app.v1.GenesisContent
 */
export class GenesisContent extends Message {
    /**
     * The initial chain identifier.
     *
     * @generated from field: string chain_id = 1;
     */
    chainId = "";
    /**
     * Stake module genesis state.
     *
     * @generated from field: penumbra.core.component.stake.v1.GenesisContent stake_content = 2;
     */
    stakeContent;
    /**
     * Shielded pool module genesis state.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.GenesisContent shielded_pool_content = 3;
     */
    shieldedPoolContent;
    /**
     * Governance module genesis state.
     *
     * @generated from field: penumbra.core.component.governance.v1.GenesisContent governance_content = 4;
     */
    governanceContent;
    /**
     * IBC module genesis state.
     *
     * @generated from field: penumbra.core.component.ibc.v1.GenesisContent ibc_content = 5;
     */
    ibcContent;
    /**
     * Sct module genesis state.
     *
     * @generated from field: penumbra.core.component.sct.v1.GenesisContent sct_content = 6;
     */
    sctContent;
    /**
     * Community Pool module genesis state.
     *
     * @generated from field: penumbra.core.component.community_pool.v1.GenesisContent community_pool_content = 7;
     */
    communityPoolContent;
    /**
     * Fee module genesis state.
     *
     * @generated from field: penumbra.core.component.fee.v1.GenesisContent fee_content = 8;
     */
    feeContent;
    /**
     * Distributions module genesis state.
     *
     * @generated from field: penumbra.core.component.distributions.v1.GenesisContent distributions_content = 9;
     */
    distributionsContent;
    /**
     * Funding module genesis state.
     *
     * @generated from field: penumbra.core.component.funding.v1.GenesisContent funding_content = 10;
     */
    fundingContent;
    /**
     * DEX component genesis state.
     *
     * @generated from field: penumbra.core.component.dex.v1.GenesisContent dex_content = 11;
     */
    dexContent;
    /**
     * Auction component genesis state.
     *
     * @generated from field: penumbra.core.component.auction.v1.GenesisContent auction_content = 12;
     */
    auctionContent;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.app.v1.GenesisContent";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "chain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "stake_content", kind: "message", T: GenesisContent$1 },
        { no: 3, name: "shielded_pool_content", kind: "message", T: GenesisContent$2 },
        { no: 4, name: "governance_content", kind: "message", T: GenesisContent$3 },
        { no: 5, name: "ibc_content", kind: "message", T: GenesisContent$4 },
        { no: 6, name: "sct_content", kind: "message", T: GenesisContent$5 },
        { no: 7, name: "community_pool_content", kind: "message", T: GenesisContent$6 },
        { no: 8, name: "fee_content", kind: "message", T: GenesisContent$7 },
        { no: 9, name: "distributions_content", kind: "message", T: GenesisContent$8 },
        { no: 10, name: "funding_content", kind: "message", T: GenesisContent$9 },
        { no: 11, name: "dex_content", kind: "message", T: GenesisContent$10 },
        { no: 12, name: "auction_content", kind: "message", T: GenesisContent$11 },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisContent, a, b);
    }
}
